import { LaneEntitySpine } from '../LaneEntitySpine';

export abstract class ObstacleSpine extends LaneEntitySpine {
  public abstract onFire(): void;

  public override recycle() {
    this.removeFromUpdateList();

    super.recycle();
  }
}
